import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const BookmarkIcon = (props: Partial<SvgIconProps>) => (
  <SvgIcon {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M15 3H5V21L12 18L19 21V7C19 4.5 17.6 3 15 3" />
  </SvgIcon>
);
